import { render, staticRenderFns } from "./LocalPricesGrid.vue?vue&type=template&id=3db2750c"
import script from "./LocalPricesGrid.vue?vue&type=script&lang=js"
export * from "./LocalPricesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports